define(function () {
    function Reviews(cb) {
        var privates = {};
        var publics = {};

        privates.init = function (cb) {
            privates.getUrl = window.location.href.replace(/\.html/, '/reviews.json');
            privates.getUrl = privates.getUrl.split('?')[0];
            privates.getUrl = privates.getUrl.split('#')[0];
            $.get(privates.getUrl, function (data) {
                const ratingCounts = { '1': 0, '2': 0, '3': 0, '4': 0, '5': 0 };

                publics.data = {
                    'reviews': data.map(item => {
                        // Count ratings while mapping
                        ratingCounts[item.rating]++;
                        return {
                            ...item,
                            avatar: Math.floor(Math.random() * 16) + 1
                        };
                    }),
                    'ratings': Object.entries(ratingCounts).map(([key, value]) => ({
                        rating: Number(key),
                        count: value,
                        ratingDecimal: data.length === 0 ? 0 : Math.round(value / data.length * 100)
                    })).sort((a, b) => b.rating - a.rating)
                };

                if (_.isFunction(cb)) {
                    cb(publics.data);
                }
            });
        };

        privates.init(cb);

        return publics;
    }

    return Reviews;
});
